exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notifiTitle--QUfrs {\n  font-style: italic; }\n\n.notification--2jQuP {\n  cursor: pointer; }\n\n.hrNoti--1xHBY {\n  margin: 1px -1px; }\n\n.timer--vZMAN {\n  font-style: italic;\n  color: #8f8f8f;\n  font-size: 8px; }\n\n.detail--60cSL {\n  font-size: 11px;\n  line-height: 1.5;\n  height: 18px;\n  display: inline-block; }\n\n.notiTitle--1lXF0 {\n  font-size: 12px;\n  font-weight: bold; }\n\n.noNotifications--3KaNV {\n  color: rgba(0, 0, 0, 0.253);\n  font-style: italic;\n  font-size: 14px;\n  text-align: center;\n  padding-top: 60px;\n  padding-bottom: 60px; }\n\n.noBorder--33EBb {\n  -webkit-transition: 0.5s !important;\n  -moz-transition: 0.5s !important;\n  -o-transition: 0.5s !important;\n  transition: 0.5s !important;\n  border-right: none !important;\n  border-left: none !important;\n  border-top: none !important;\n  border-bottom: 2px solid #eeeeee !important; }\n  .noBorder--33EBb.newNotification--35XIe {\n    background: cornsilk !important; }\n\n.showReadNoti--1HzSH {\n  text-align: center !important;\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n  border-bottom: none !important; }\n\n.content--1Hqgn {\n  overflow: auto; }\n\n.headerNotification--2KOr_ {\n  font-size: 10px;\n  font-weight: 0; }\n\n.exitButton--iaveT {\n  line-height: 17px;\n  padding: 1px 5px;\n  float: right; }\n\n.exitButton--iaveT:hover {\n  background: #e6e6e6; }\n\n.exitButton--iaveT:active {\n  background: #6b6b6b; }\n\n.nomousepointer--3hZ7S {\n  cursor: default; }\n", ""]);

// exports
exports.locals = {
	"notifiTitle": "notifiTitle--QUfrs",
	"notification": "notification--2jQuP",
	"hrNoti": "hrNoti--1xHBY",
	"timer": "timer--vZMAN",
	"detail": "detail--60cSL",
	"notiTitle": "notiTitle--1lXF0",
	"noNotifications": "noNotifications--3KaNV",
	"noBorder": "noBorder--33EBb",
	"newNotification": "newNotification--35XIe",
	"showReadNoti": "showReadNoti--1HzSH",
	"content": "content--1Hqgn",
	"headerNotification": "headerNotification--2KOr_",
	"exitButton": "exitButton--iaveT",
	"nomousepointer": "nomousepointer--3hZ7S"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[local]--[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/NotificationCenter/NotificationCenter.scss
// module id = 549
// module chunks = 4